import { createFileRoute } from "@tanstack/react-router";
import { TermsPage } from "../../../features/terms";

export const Route = createFileRoute("/$lang/_layout/terms-of-service")({
  component: TermsPage,
});
